import {ApiService} from "./ApiService";
import moment from "moment";

export const VscsApi = {

    venue(venueId) {
        return ApiService.get('/api/v1/venue', {venueId: venueId})
    },

    venues(regionCode, religionId = "-1", withCamera = 0) {
        let params = {}
        if (regionCode) {
            params.regionCode = regionCode
        }
        if (religionId) {
            params.religionId = religionId
        }
        if (withCamera) {
            params.withCamera = withCamera
        }
        return ApiService.get("/api/v1/venue/list", params)
    },

    venueCount() {
        return ApiService.get('/api/v1/venue/count')
    },

    venueCameras(venueId) {
        return ApiService.get('/api/v1/venue/cameras', {venueId: venueId})
    },

    venueRealtimeFaces(venueId) {
        return ApiService.get('/api/v1/venue/realtime/face', {venueId: venueId})
    },

    person(personId) {
        return ApiService.get("/api/v1/vscs/person", {
            personId: personId
        })
    },

    searchPerson(personId = null, page = 0) {
        let params = {
            page: page
        }
        if (personId) {
            params.personId = personId
        }
        return ApiService.get("/api/v1/vscs/person/search", params)
    },

    mixPerson(targetPersonId, sourcePersonId) {
        return ApiService.post("/api/v1/vscs/person/mix", {
            targetPersonId: targetPersonId,
            sourcePersonId: sourcePersonId
        })
    },

    mixPersons(personIds) {
      return ApiService.postJson("/api/v1/vscs/person/mix/persons", personIds)
    },

    flow(startTime = moment(), endTime = moment(), regionCode, religionId) {
        let params = {
            startTime: startTime.startOf("day").unix() * 1000,
            endTime: endTime.endOf("day").unix() * 1000
        }
        if (regionCode) {
            params.regionCode = regionCode
        }
        if (religionId) {
            params.religionId = religionId
        }
        return ApiService.get("/api/v1/vscs/flow", params)
    },

    flowPerson(startTime = moment(), endTime = moment(), regionCode, religionId, venueId) {
        let params = {
            startTime: startTime.startOf("day").unix() * 1000,
            endTime: endTime.endOf("day").unix() * 1000
        }
        if (regionCode) {
            params.regionCode = regionCode
        }
        if (religionId) {
            params.religionId = religionId
        }
        if (venueId) {
            params.venueId = venueId
        }
        return ApiService.get("/api/v1/vscs/flow/person", params)
    },

    personTimeline(personId, page = 0) {
        return ApiService.get("/api/v1/vscs/person/timeline", {
            personId: personId,
            page: page
        })
    },

    personFaces(personId, page = 0) {
        return ApiService.get("/api/v1/vscs/person/faces", {
            personId: personId,
            page: page
        })
    },

    personFrequency(page = 0) {
        return ApiService.get("/api/v1/vscs/person/frequency", {
            page: page,
        })
    },

    removePerson(personId) {
        return ApiService.post("/api/v1/vscs/person/remove", {
            personId: personId,
        })
    },

    deletePerson(personId) {
        return ApiService.post("/api/v1/vscs/person/delete", {
            personId: personId,
        })
    },

    resetFace(personFaceId) {
        return ApiService.post("/api/v1/vscs/person/reset/face", {
            personFaceId: personFaceId,
        })
    },

    removeFace(personFaceId) {
        return ApiService.post("/api/v1/vscs/person/remove/face", {
            personFaceId: personFaceId,
        })
    },

    setPersonFaceCover(personFaceId) {
        return ApiService.post("/api/v1/vscs/person/cover", {
            personFaceId: personFaceId,
        })
    },

    reportDaily(date) {
        return ApiService.get("/api/v1/vscs/report/daily", {date: date})
    }
}